import { useEffect, useRef, useState } from "react";
import { generateID } from "../../utils/utils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

export default function ComboBoxV2(props) {
  const [value, setValue] = useState(props.value || "");
  const onFocus = props.onFocus || null;
  const onBlur = props.onBlur || null;
  const onChange = props.onChange || null;
  const index = props.index || null;
  const option = props.option || null;
  const name = props.name || `combo-box-${generateID()}`;
  const id = props.id || `combo-box-${generateID()}`;
  const classNameLabel = props.classNameLabel || null;
  const className = props.className || null;
  const label = props.label || null;
  const placeholder = props.placeholder || null;
  const searchPlaceholder = props.searchPlaceholder || "ค้นหา";
  const onSearch = props.onSearch || null;
  const itemsLists = props.itemsLists || [];
  const itemsListsAll = props.itemsAll || [];
  const [seachItems, setSeachItems] = useState(itemsLists);

  const combobox = useRef(null);
  const searchName = `combo-box-search-${generateID()}`;
  const searchId = `combo-box-search-${generateID()}`;
  const [expandItemListStatus, setExpandItemListStatus] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const handleClose = (data) => {
    setExpandItemListStatus(false);
    if (option && index && typeof data === "object") {
      if (data[option] && data[index]) {
        setValue(data[option]);
        if (onChange) {
          onChange({
            $value: data[index],
            $option: data[option],
            $items: data,
          });
        }
      }
    } else {
      setValue(data);
      if (onChange) {
        onChange({
          $value: data,
          $option: data,
          $items: data,
        });
      }
    }
  };
  const toggleExpand = (e) => {
    setExpandItemListStatus(!expandItemListStatus);
    if (!expandItemListStatus) {
      setSeachItems(itemsLists);
    }
  };

  const SearchItem = (e) => {
    const search = e.target.value;
    setSearchValue(search);

    if (search !== "") {
      let filteredItems = [];

      // ถ้ามีช่องว่าง ให้ตรวจสอบ itemsListsAll สำหรับ exact match
      if (search.includes(" ")) {
        filteredItems = itemsListsAll.filter((data) => {
          const itemName =
            option && typeof data === "object" ? data[option] : data.toString();
          return itemName.trim() === search.trim();
        });
      }

      // ถ้ายังไม่มีผลลัพธ์หรือไม่ได้ค้นหาแบบ full name ให้ค้นหาแบบปกติใน itemsLists
      if (filteredItems.length === 0) {
        if (
          option &&
          index &&
          typeof itemsLists.some((data) => typeof data === "object")
        ) {
          filteredItems = itemsLists.filter((data) => {
            const regex = new RegExp(search.toString(), "gi");
            const matched = data[option].toString().match(regex);
            return matched;
          });
        } else {
          filteredItems = itemsLists.filter((data) => {
            const regex = new RegExp(search.toString(), "gi");
            return data.toString().match(regex);
          });
        }
      }

      setSeachItems(filteredItems);
    } else {
      setSeachItems(itemsLists);
    }
    if (onSearch) {
      onSearch(e);
    }
  };

  useEffect(() => {
    document.addEventListener("click", (e) => {
      if (combobox.current && !combobox.current.contains(e.target)) {
        setExpandItemListStatus(false);
        setSearchValue("");
      }
    });
  }, []);

  return (
    <div ref={combobox} className="relative z-40">
      {label ? (
        <label htmlFor={id} className={classNameLabel ? classNameLabel : ""}>
          {label}
        </label>
      ) : null}
      <div className="relative inline-block w-full rounded-[5px] mt-[4px] border border-[#A2B5BC]">
        <input
          type="text"
          id={id}
          name={name}
          value={value}
          readOnly
          placeholder={placeholder}
          onFocus={(e) => onFocus}
          onBlur={(e) => onBlur}
          onClick={(e) => {
            toggleExpand(e);
          }}
          className={
            className
              ? className
              : "w-full h-full rounded-[5px] py-2 ps-[0.625rem] pe-5 cursor-pointer select-none focus-visible:outline-0"
          }
        />
        {value ? (
          <>
            <button
              onClick={(e) => {
                setValue("");
              }}
              className={`absolute top-1/2 -translate-y-1/2 right-[0.75rem] text-gray-400`}
            >
              <CloseIcon sx={{ fontSize: 18 }} />
            </button>
          </>
        ) : (
          <>
            <span
              className={`absolute top-1/2 -translate-y-1/2 right-[0.75rem] text-gray-400 cursor-pointer pointer-events-none transition-all ${
                expandItemListStatus ? "-rotate-180" : ""
              }`}
            >
              <ExpandMoreIcon />
            </span>
          </>
        )}
      </div>

      <div
        className={`absolute bg-white top-full left-0 w-full shadow-lg max-h-[250px] flex-col overflow-hidden h-auto rounded-b-lg ${
          expandItemListStatus ? "flex" : "hidden"
        }`}
      >
        <div className="relative px-2 py-2.5 border-b">
          <input
            type="text"
            id={searchId}
            name={searchName}
            placeholder={searchPlaceholder}
            value={searchValue}
            onInput={(e) => {
              SearchItem(e);
            }}
            className="border border-gray-300 rounded-md w-full h-full focus-visible:outline-0 py-2 ps-2.5 pe-7"
          />
          <span className="absolute top-1/2 -translate-y-1/2 right-[0.75rem] text-gray-400">
            <SearchIcon />
          </span>
        </div>
        {seachItems.length > 0 ? (
          <>
            <div className="h-full overflow-auto">
              <ul>
                {seachItems.map((item, index) => (
                  <li key={index} className="[&:not(:first-child)]:border-t">
                    <button
                      type="button"
                      className="px-6 py-2.5 w-full text-start hover:bg-gray-100"
                      onClick={(e) => {
                        handleClose(item);
                      }}
                    >
                      {option && typeof item === "object"
                        ? item[option] ?? item.toString()
                        : item.toString()}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : (
          <>
            <div className="relative px-4 py-2.5">
              <span className="text-gray-400 select-none">ไม่พบรายการ</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
